export default __webpack_public_path__ + "static/media/image-gallery-1.ab84752e.jpg";